import colors from "../../base/colors";
import root from "../button/root";
import contained from "../button/contained";
import outlined from "../button/outlined";
import buttonText from "../button/text";

const { text } = colors;

const button = {
  defaultProps: {
    disableRipple: false,
    size: "medium",
  },
  styleOverrides: {
    root: { ...root },
    contained: { ...contained.base },
    containedSizeSmall: { ...contained.small },
    containedSizeLarge: { ...contained.large },
    containedPrimary: { ...contained.primary },
    containedSecondary: { ...contained.secondary },
    containedSuccess: { ...contained.success },
    containedWarning: { ...contained.warning },
    containedError: { ...contained.error },
    containedDark: { ...contained.dark },
    containedInfo: { ...contained.info },
    outlined: { ...outlined.base },
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    outlinedPrimary: { ...outlined.primary },
    outlinedSecondary: { ...outlined.secondary },
    outlinedSuccess: { ...outlined.success },
    outlinedWarning: { ...outlined.warning },
    outlinedError: { ...outlined.error },
    outlinedDark: { ...outlined.dark },
    outlinedInfo: { ...outlined.info },
    outlinedInherit: {
      color: text.main,
      borderColor: "rgba(255, 255, 255, 0.35)",
      "&:hover": {
        backgroundColor: "rgba(255, 255, 255, 0.08)",
        borderColor: "rgba(255, 255, 255, 0.5)",
      },
    },
    text: { ...buttonText.base },
    textSizeSmall: { ...buttonText.small },
    textSizeLarge: { ...buttonText.large },
    textPrimary: { ...buttonText.primary },
    textSecondary: { ...buttonText.secondary },
    textSuccess: { ...buttonText.success },
    textWarning: { ...buttonText.warning },
    textError: { ...buttonText.error },
    textDark: { ...buttonText.dark },
  },
};

export default button;
